module.exports = __webpack_public_path__ + "img/stop_btn.44830d67.png";